import actions from './actions';
export * from './actions';
export * from './selectors';

export const CustomerActions = actions;
export default actions;



// WEBPACK FOOTER //
// ./src/redux-modules/customers/index.js